@if (project()) {
  <div
    class="w-full rounded-md border border-proffeo-overlay-subtle bg-proffeo-surface p-4 grid grid-cols-1 lg:grid-cols-3 gap-4"
  >
    <div class="flex items-center justify-center">
      <proffeo-ui-button
        (clicked)="onExportTaskImportTemplate()"
        [text]="'company-projects.list-actions.export-task-import-template'"
      />
    </div>
    <div class="flex flex-col gap-2">
      <proffeo-file-drop (filesAdded)="onFilesAdded($event)" />
    </div>
    <div class="flex flex-col gap-2">
      <div class="rounded-lg border border-proffeo-border overflow-hidden">
        <table class="w-full min-w-full border-collapse">
          <thead class="bg-proffeo-surface-muted border-b border-proffeo-border">
            <tr>
              <th class="text-left text-sm font-semibold text-proffeo-text px-3 py-2">
                {{ 'project-tasks.import-from-template.file-name' | translate }}
              </th>
              <th class="text-left text-sm font-semibold text-proffeo-text px-3 py-2">
                {{ 'project-tasks.import-from-template.status' | translate }}
              </th>
              <th class="text-left text-sm font-semibold text-proffeo-text px-3 py-2">
                {{ 'project-tasks.import-from-template.imported' | translate }}
              </th>
              <th class="text-left text-sm font-semibold text-proffeo-text px-3 py-2">
                {{ 'project-tasks.import-from-template.errors' | translate }}
              </th>
            </tr>
          </thead>
          <tbody>
            @for (item of fileList(); track item.id) {
              <tr class="border-b border-proffeo-border hover:bg-proffeo-surface-muted/50">
                <td class="px-3 py-2 text-sm">{{ item.fileName }}</td>
                <td class="px-3 py-2 text-sm text-proffeo-text">
                  {{ getStatusKey(item.status) | translate }}
                </td>
                <td class="px-3 py-2 text-sm text-proffeo-text">
                  @if (item.status === 'processed' || item.status === 'failed') {
                    {{ item.importedCount ?? '—' }}
                  } @else {
                    —
                  }
                </td>
                <td class="px-3 py-2 text-sm">
                  @if (item.errors && item.errors.length > 0) {
                    <button
                      (click)="toggleErrors(item.id)"
                      type="button"
                      class="cursor-pointer underline text-proffeo-accent-600 hover:text-proffeo-accent-700"
                    >
                      {{ item.errors.length }}
                    </button>
                  } @else if (item.status === 'processed' || item.status === 'failed') {
                    0
                  } @else {
                    —
                  }
                </td>
              </tr>
            } @empty {
              <tr>
                <td
                  colspan="4"
                  class="px-3 py-4 text-sm text-proffeo-muted text-center"
                >
                  {{ 'project-tasks.import-from-template.placeholder' | translate }}
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      @for (item of fileList(); track item.id) {
        @if (expandedErrorsForId() === item.id && item.errors && item.errors.length > 0) {
          <div
            class="mt-2 rounded-lg border border-proffeo-feedback-danger-border bg-proffeo-feedback-danger-surface/50 p-3"
          >
            <h4 class="text-sm font-semibold mb-2">
              {{ 'project-tasks.import-from-template.error-details-title' | translate }}
              ({{ item.fileName }})
            </h4>
            <ul class="list-none space-y-1 text-sm">
              @for (err of item.errors; track $index) {
                <li class="flex flex-wrap gap-x-2 gap-y-1 text-proffeo-text">
                  @if (err.rowNumber !== null && err.rowNumber !== undefined) {
                    <span>{{ 'project-tasks.import-from-template.error-row' | translate }}: {{ err.rowNumber }}</span>
                  }
                  @if (err.column) {
                    <span>{{ 'project-tasks.import-from-template.error-column' | translate }}: {{ err.column }}</span>
                  }
                  @if (err.message) {
                    <span>{{ 'project-tasks.import-from-template.error-message' | translate }}: {{ err.message }}</span>
                  }
                </li>
              }
            </ul>
          </div>
        }
      }
    </div>
  </div>
} @else {
  <div class="w-full rounded-md border border-proffeo-overlay-subtle bg-proffeo-surface-muted p-4">
    <p class="text-sm text-proffeo-muted">
      {{ 'project-tasks.import-from-template.no-project' | translate }}
    </p>
  </div>
}
